<nav class="nav-rail" aria-label="Primary">
  <div
    class="nav-rail__item"
    *ngFor="let section of sections"
    role="button"
    tabindex="0"
    [class.nav-rail__item--active]="activeId === section.id"
    [class.nav-rail__item--preview]="previewId === section.id && activeId !== section.id"
    (mouseenter)="onHover(section)"
    (mouseleave)="onItemLeave(section, $event)"
    (click)="onClick(section, $event)"
    (keydown.enter)="onClick(section, $event)"
    (keydown.space)="$event.preventDefault(); onClick(section, $event)"
    [attr.aria-current]="activeId === section.id ? 'page' : null"
    [attr.title]="section.label"
    [style.--nav-color]="navColor(section.bgColor)">
    <span class="nav-rail__icon">
      <i [ngClass]="section.icon"></i>
    </span>
    <span class="nav-rail__label">{{ section.label }}</span>
  </div>
</nav>
